module.exports = global["VideoPlayer"] = require("-!X:\\Projects\\js-components\\Jyllands-Posten\\VideoPlayer\\node_modules\\awesome-typescript-loader\\dist\\entry.js!.\\VideoPlayer.ts");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?VideoPlayer!./VideoPlayer/VideoPlayer.ts
// module id = 31
// module chunks = 0